import React from 'react'

// icons : feather
import FeatherIcon from 'feather-icons-react';

export default function PageTabsLinks(props) {
    // props
    const {
        formik,

        pageActiveTab,
        handleTabView,
        errorInCategories
    } = props


    return (
        <div className="st-tabs-links">
            <div className="stl-inner">
                {/* tab link */}
                <a
                    href="#general_tab"
                    className={`stl-link d-inline-flex align-items-center text-capitalize 
                    ${pageActiveTab === "general_tab" ? "active" : ""}
                    ${(
                            (formik.touched.productName && formik.errors.productName) ||
                            (formik.touched.SKU && formik.errors.SKU) ||
                            (formik.touched.longDescription && formik.errors.longDescription) ||
                            (formik.touched.shortDescription && formik.errors.shortDescription) ||
                            (formik.touched.ribbonText && formik.errors.ribbonText) ||
                            (errorInCategories)
                        ) ? "has-error" : ""}
                    `}
                    onClick={ev => handleTabView(ev, 'general_tab')}>
                    {
                        (
                            (formik.touched.productName && formik.errors.productName) ||
                            (formik.touched.SKU && formik.errors.SKU) ||
                            (formik.touched.longDescription && formik.errors.longDescription) ||
                            (formik.touched.shortDescription && formik.errors.shortDescription) ||
                            (formik.touched.ribbonText && formik.errors.ribbonText) ||
                            (errorInCategories)
                        ) ? (
                            <FeatherIcon
                                icon="alert-circle"
                                size="12"
                                className="icon cursor-pointer me-2"
                            />
                        ) : null
                    }
                    <span>general</span>
                </a>

                {/* tab link */}
                <a
                    href="#attributes_tab"
                    className={`stl-link d-inline-flex align-items-center text-capitalize 
                    ${pageActiveTab === "attributes_tab" ? "active" : ""}
                    ${(
                            (formik.touched.UPC && formik.errors.UPC)) ? "has-error" : ""
                        }
                    `}
                    onClick={ev => handleTabView(ev, 'attributes_tab')}>
                    {
                        (
                            (formik.touched.UPC && formik.errors.UPC)
                        ) ? (
                            <FeatherIcon
                                icon="alert-circle"
                                size="12"
                                className="icon cursor-pointer me-2"
                            />
                        ) : null
                    }
                    <span>attributes</span>
                </a>

                {/* tab link */}
                <a
                    href="#variations_tab"
                    className={`stl-link d-inline-flex align-items-center text-capitalize 
                    ${pageActiveTab === "variations_tab" ? "active" : ""}
                    ${(false) ? "has-error" : ""
                        }
                    `}
                    onClick={ev => handleTabView(ev, 'variations_tab')}>
                    {
                        (false) ? (
                            <FeatherIcon
                                icon="alert-circle"
                                size="12"
                                className="icon cursor-pointer me-2"
                            />
                        ) : null
                    }
                    <span>variations</span>
                </a>

                {/* tab link */}
                <a
                    href="#seo_tab"
                    className={`stl-link d-inline-flex align-items-center text-capitalize 
                    ${pageActiveTab === "seo_tab" ? "active" : ""}
                    ${(
                            (formik.touched.metaTitle && formik.errors.metaTitle) ||
                            (formik.touched.metaDescription && formik.errors.metaDescription)) ? "has-error" : ""
                        }
                    `}
                    onClick={ev => handleTabView(ev, 'seo_tab')}>
                    {
                        (
                            (formik.touched.metaTitle && formik.errors.metaTitle) ||
                            (formik.touched.metaDescription && formik.errors.metaDescription)
                        ) ? (
                            <FeatherIcon
                                icon="alert-circle"
                                size="12"
                                className="icon cursor-pointer me-2"
                            />
                        ) : null
                    }
                    <span>SEO</span>
                </a>

                {/* tab link */}
                {/* <a
                    href="#files_tab"
                    className={`stl-link d-inline-flex align-items-center text-capitalize 
                    ${pageActiveTab === "files_tab" ? "active" : ""}
                    ${(false) ? "has-error" : ""
                        }
                    `}
                    onClick={ev => handleTabView(ev, 'files_tab')}>
                    {
                        (false) ? (
                            <FeatherIcon
                                icon="alert-circle"
                                size="12"
                                className="icon cursor-pointer me-2"
                            />
                        ) : null
                    }
                    <span>files</span>
                </a> */}

                {/* tab link */}
                {/* <a
                    href="#tax_and_shipping_tab"
                    className={`stl-link d-inline-flex align-items-center text-capitalize 
                    ${pageActiveTab === "tax_and_shipping_tab" ? "active" : ""}
                    ${(false) ? "has-error" : ""
                        }
                    `}
                    onClick={ev => handleTabView(ev, 'tax_and_shipping_tab')}>
                    {
                        (false) ? (
                            <FeatherIcon
                                icon="alert-circle"
                                size="12"
                                className="icon cursor-pointer me-2"
                            />
                        ) : null
                    }
                    <span>tax and shipping</span>
                </a> */}

                <a
                    href="#purchasability_tab"
                    className={`stl-link d-inline-flex align-items-center text-capitalize 
                    ${pageActiveTab === "purchasability_tab" ? "active" : ""}
                    ${(false) ? "has-error" : ""
                        }
                    `}
                    onClick={ev => handleTabView(ev, 'purchasability_tab')}>
                    {
                        (false) ? (
                            <FeatherIcon
                                icon="alert-circle"
                                size="12"
                                className="icon cursor-pointer me-2"
                            />
                        ) : null
                    }
                    <span>Purchasability</span>
                </a>

                {/* tab link */}
                {/* <a
                    href="#related_products_tab"
                    className={`stl-link d-inline-flex align-items-center text-capitalize 
                    ${pageActiveTab === "related_products_tab" ? "active" : ""}
                    ${(false) ? "has-error" : ""
                        }
                    `}
                    onClick={ev => handleTabView(ev, 'related_products_tab')}>
                    {
                        (false) ? (
                            <FeatherIcon
                                icon="alert-circle"
                                size="12"
                                className="icon cursor-pointer me-2"
                            />
                        ) : null
                    }
                    <span>related products</span>
                </a> */}

                {/* tab link */}
                {/* <a
                    href="#buy_now_tab"
                    className={`stl-link d-inline-flex align-items-center text-capitalize 
                    ${pageActiveTab === "buy_now_tab" ? "active" : ""}
                    ${(
                            (formik.touched.productName && formik.errors.productName) ||
                            (formik.touched.SKU && formik.errors.SKU) ||
                            (formik.touched.longDescription && formik.errors.longDescription) ||
                            (formik.touched.shortDescription && formik.errors.shortDescription)) ? "has-error" : ""
                        }
                    `}
                    onClick={ev => handleTabView(ev, 'buy_now_tab')}>
                    {
                        (
                            (formik.touched.productName && formik.errors.productName) ||
                            (formik.touched.SKU && formik.errors.SKU) ||
                            (formik.touched.longDescription && formik.errors.longDescription) ||
                            (formik.touched.shortDescription && formik.errors.shortDescription)
                        ) ? (
                            <FeatherIcon
                                icon="alert-circle"
                                size="12"
                                className="icon cursor-pointer me-2"
                            />
                        ) : null
                    }
                    <span>"Buy Now" button</span>
                </a> */}


            </div>
        </div>
    )
}
